import Link from 'next/link';
import { useRouter } from 'next/router';

function Pagination({data}) {
    if(data.last_page<=data.from)
    {
      return null;
    }
    const router = useRouter();
    const pages = Array.from({ length: data.current_page + 5 < data.last_page ? 5 - data.current_page : data.last_page }, (_, i) => i + 1);
    const start_page = data.current_page>2 ? data.current_page-2 : 1; 

    const pageNumClick = (page) => {
      router.push({
        pathname: router.pathname,
        query: { ...router.query, page },
      });
    };
  

    return (<nav aria-label="Page navigation" className="mt-3">
    <ul className="pagination">
      {data.current_page != data.from??
      <li className="page-item">
        <Link href={{
              pathname: router.pathname,
              query: { ...router.query, page:data.from },
            }} 
            passHref
            shallow
            replace
            legacyBehavior>
          <a className="page-link" onClick={() => pageNumClick(data.from)}><i className="las la-angle-right"></i></a>
        </Link>
      </li>
      }
    
      {pages.map((value, index)  => (
      <li key={index} className="page-item">
        <Link href={{
            pathname: router.pathname,
            query: { ...router.query, page:(index+start_page) },
          }}
          passHref
          shallow
          replace legacyBehavior>
            <a
              className={`page-link ${data.current_page==(index+start_page) ? 'active' : ''}`}
              onClick={() => pageNumClick((index+start_page))} >{(index+start_page)}</a>
        </Link>
      </li>
      ))}

 
      {data.current_page != data.last_page??
      <li className="page-item">
        <Link href={{
              pathname: router.pathname,
              query: { ...router.query, page:data.last_page },
            }}
            passHref
            shallow
            replace 
            legacyBehavior>
          <a className="page-link" onClick={() => pageNumClick(data.last_page)}><i className="las la-angle-left"></i></a>
        </Link>
      </li>
      }
    </ul>
  </nav>);
}
export default Pagination;